import React from "react";

const scopeSegments = [
  { label: "Scope 1", value: 24, color: "#fc6bd6" },
  { label: "Scope 2", value: 36, color: "#19b8d2" },
  { label: "Scope 3", value: 40, color: "#16a34a" },
];

const radius = 72;
const circumference = 2 * Math.PI * radius;

export function ScopePieChart() {
  let offset = 0;

  return (
    <div className="scope-chart-card" aria-hidden="true">
      <div className="scope-chart-header">
        <span>Emissions split</span>
        <strong>Scope 1, 2 and 3</strong>
      </div>
      <div className="scope-pie-layout">
        <svg className="scope-pie" viewBox="0 0 220 220" role="presentation">
          <circle className="scope-pie-track" cx="110" cy="110" r={radius} />
          {scopeSegments.map((segment) => {
            const dash = (segment.value / 100) * circumference;
            const currentOffset = offset;
            offset += dash;

            return (
              <circle
                key={segment.label}
                className="scope-pie-segment"
                cx="110"
                cy="110"
                r={radius}
                stroke={segment.color}
                strokeDasharray={`${dash} ${circumference - dash}`}
                strokeDashoffset={-currentOffset}
              />
            );
          })}
          <text x="110" y="104" textAnchor="middle">100%</text>
          <text x="110" y="126" textAnchor="middle">Reported</text>
        </svg>
        <div className="scope-legend">
          {scopeSegments.map((segment) => (
            <div key={segment.label}>
              <i style={{ background: segment.color }} />
              <span>{segment.label}</span>
              <strong>{segment.value}%</strong>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export function ScopeTimeSeriesChart() {
  return (
    <div className="scope-chart-card" aria-hidden="true">
      <div className="scope-chart-header">
        <span>Reporting trend</span>
        <strong>Scope movement over time</strong>
      </div>
      <svg className="scope-timeseries" viewBox="0 0 520 260" role="presentation">
        <g className="scope-grid">
          <line x1="44" y1="42" x2="492" y2="42" />
          <line x1="44" y1="92" x2="492" y2="92" />
          <line x1="44" y1="142" x2="492" y2="142" />
          <line x1="44" y1="192" x2="492" y2="192" />
        </g>
        <g className="scope-axis">
          <text x="44" y="230">Q1</text>
          <text x="156" y="230">Q2</text>
          <text x="268" y="230">Q3</text>
          <text x="380" y="230">Q4</text>
        </g>
        <path className="scope-line scope-one" d="M44 166 C100 154, 112 150, 156 148 S232 138, 268 126 S344 118, 380 104 S452 100, 492 88" />
        <path className="scope-line scope-two" d="M44 132 C92 126, 112 120, 156 116 S232 108, 268 96 S344 88, 380 82 S452 78, 492 66" />
        <path className="scope-line scope-three" d="M44 84 C96 92, 116 88, 156 76 S232 78, 268 70 S344 58, 380 52 S452 44, 492 38" />
        <g className="scope-points">
          <circle cx="492" cy="88" r="5" />
          <circle cx="492" cy="66" r="5" />
          <circle cx="492" cy="38" r="5" />
        </g>
      </svg>
      <div className="scope-line-legend">
        {scopeSegments.map((segment) => (
          <span key={segment.label}>
            <i style={{ background: segment.color }} />
            {segment.label}
          </span>
        ))}
      </div>
    </div>
  );
}
